module.exports = __webpack_public_path__ + "static/img/son3.049c0d54.png";